<template>
  <div class="pb-2 pt-0 ml-2 border-radius">
    <div class="row import-config-view">
      <h4 class="mt-2 ml-2">{{ $t('Summary') }}</h4>
      <template
          v-if="content.pipeline">
        <div v-for="(field) in filteredFields"
             :key="field"
             :class="['w-100 d-flex']">
          <div class="col-12 col-md-4 mt-1 pl-2 lighter">{{ $t(field) }}</div>
          <div class="col-12 col-md-8 mt-1">{{ itemToString(content.pipeline[field]) }}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImportViewer",
  props: {
    content: {type: Object, default: () => {return {}}}
  },
  data() {
    return {
      showFields: [
        "rootNodeFile",
        "outputFormats",
        "lod",
        "pivotPlacement",
        "files",
        "email"
      ],
    }
  },
  computed: {
    filteredFields() {
      if(this.content && this.content.pipeline) {
        return Object.keys(this.content.pipeline).filter(key => this.showFields.includes(key));
      }
      return [];
    }
  },
  methods: {
    getLastPartOfString(str) {
      return str.split('/').pop();
    },
    itemToString(item) {
      if(Array.isArray(item)) {
        return item.map(string => {return this.getLastPartOfString(string)}).join(' | ');
      }
      return item;
    }
  }
}
</script>